import QrCodeInviteForm from "@/features/qr-code/components/QrCodeInviteForm";
import { createFileRoute } from "@tanstack/react-router";

const OrganisationQuickstartQrCodePage = () => {
	const { organisationId } = Route.useParams();
	return (
		<QrCodeInviteForm
			defaultRole="PATIENT"
			defaultOrganisationId={organisationId}
		/>
	);
};

export const Route = createFileRoute(
	"/_app/organisation/$organisationId/qr-code",
)({
	component: OrganisationQuickstartQrCodePage,
});
